import { combineReducers } from 'redux';

import { RESET_ALL_STATES } from '@/redux/mutations';
import propertyReducer from '@/redux/reducers/propertyReducer';

import alertReducer from './alertReducer';
import authReducer from './authReducer';
import checkAgroV2Reducer from './checkAgroV2';
import confirmDialogReducer from './confirmDialogReducer';
import dashboardReducer from './dashboardReducer';
import enterpriseReducer from './enterpriseReducer';
import indicatorsPanelClinicalMastitisReducer from './indicatorsPanelClinicalMastitisReducer';
import indicatorsPanelIllnessRecriationReducer from './indicatorsPanelIllnessRecriationReducer';
import indicatorsPanelIllnessReducer from './indicatorsPanelIllnessReducer';
import indicatorsPanelMilkingControlReducer from './indicatorsPanelMilkingControlReducer';
import indicatorsPanelMilkProductionReducer from './indicatorsPanelMilkProductionReducer';
import indicatorsPanelReplacementReducer from './indicatorsPanelReplacementReducer';
import indicatorsPanelReproductionReducer from './indicatorsPanelReproductionReducer';
import indicatorsPanelSubclinicalMastitisReducer from './indicatorsPanelSubclinicalMastitisReducer';
import indicatorsPanelTankReducer from './indicatorsPanelTankReducer';
import indicatorsPanelWeaningReducer from './indicatorsPanelWeaningReducer';
import managerPanelReducer from './ManagerPanel';
import notificationReducer from './notificationsReducer';
import producerReducer from './producerReducer';
import simulatorReducer from './simulatorReducer';
import snackbarReducer from './snackbarReducer';
import tabsDiagnosticReducer from './tabsDiagnosticReducer';
import tourReducer from './tourReducer';
import userActionPlansReducer from './userActionPlansReducer';
import userEventReducer from './userEventReducer';
import userPropertiesReducer from './userPropertiesReducer';

const appReducer = combineReducers({
    auth: authReducer,
    dashboard: dashboardReducer,
    snackbar: snackbarReducer,
    confirmDialog: confirmDialogReducer,
    tabsDiagnostic: tabsDiagnosticReducer,
    producer: producerReducer,
    property: propertyReducer,
    enterprises: enterpriseReducer,
    alert: alertReducer,
    userEvent: userEventReducer,
    userProperties: userPropertiesReducer,
    userActionPlans: userActionPlansReducer,
    notification: notificationReducer,
    tour: tourReducer,
    managerPanelReducer: managerPanelReducer,
    indicatorsPanelMilkingControl: indicatorsPanelMilkingControlReducer,
    indicatorsPanelSubclinicalMastitis: indicatorsPanelSubclinicalMastitisReducer,
    indicatorsPanelClinicalMastitis: indicatorsPanelClinicalMastitisReducer,
    indicatorsPanelReplacement: indicatorsPanelReplacementReducer,
    indicatorsPanelMilkProduction: indicatorsPanelMilkProductionReducer,
    indicatorsPanelTank: indicatorsPanelTankReducer,
    indicatorsPanelReproduction: indicatorsPanelReproductionReducer,
    indicatorsPanelIllness: indicatorsPanelIllnessReducer,
    indicatorsPanelIllnessRecreation: indicatorsPanelIllnessRecriationReducer,
    indicatorsPanelWeaning: indicatorsPanelWeaningReducer,
    checkAgroV2: checkAgroV2Reducer,
    simulator: simulatorReducer
});

// Root reducer que intercepta a action RESET_ALL_STATES
const rootReducer = (state, action) => {
    if (action.type === RESET_ALL_STATES) {
        // Retorna undefined para resetar todos os estados para seus valores iniciais
        state = undefined;
    }

    return appReducer(state, action);
};

export default rootReducer;
